import { Controller, useFormContext } from "react-hook-form"
import { FilterToggleButton } from "./FilterToggleButton"

interface FilterToggleProps {
  name: string
  label: string
}
export const FilterToggle = ({ name, label }: FilterToggleProps) => {
  const formApi = useFormContext()
  return (
    <Controller
      name={name}
      render={({ field }) => (
        <FilterToggleButton
          label={label}
          checked={field.value}
          // Unregister instead of setting `false` to keep the form values clean
          onChange={(checked) =>
            checked ? field.onChange(true) : formApi.unregister(name)
          }
        />
      )}
    />
  )
}
